import React from 'react'
const PublicVariablesContext = React.createContext({})

PublicVariablesContext.displayName = "PublicVariablesContext"

export default PublicVariablesContext
